<template>
  <div>
    <b-modal size="lg" id="selectImageModal" ref="selectImageModal" lazy>
      <template #modal-title>Select Image</template>
      <template #modal-footer>
        <b-button variant="secondary" @click="$refs.selectImageModal.hide()"
          >Cancel</b-button
        >
      </template>
      <div style="text-align: center; width: 100%">
        <div v-for="image in images" class="imageButtonContainer">
          <img
            :src="image.url"
            style="cursor: pointer; width: 100%"
            @click="setImage(image.id)"
          />
          <hr />
        </div>
      </div>
    </b-modal>

    <div class="imageButtonContainer" style="text-align: center">
      <img
        :src="'img/membership/' + formMembership.imageId"
        style="width: 100%"
      />
      <button class="btn" @click="changeImage">Change Image</button>
    </div>

    <hr />
    <validation-observer ref="formValidator" v-slot="{ handleSubmit }">
      <b-form role="form" @submit.prevent="handleSubmit(submit)">
        <b-row>
          <b-col>
            <label class="form-control-label">Membership Label</label>
            <base-input
              class="mb-3"
              name="label"
              rules="required"
              mode="lazy"
              v-model="formMembership.label"
            />
          </b-col>
          <b-col>
            <label class="form-control-label">Monthly Amount</label>
            <base-input-currency
              class="mb-3"
              name="amount"
              prependChar="$"
              prepend=""
              rules="required|money"
              mode="lazy"
              v-model="formMembership.monthlyAmount"
            />
          </b-col>
          <b-col>
            <label class="form-control-label">Yearly Amount</label>
            <base-input-currency
              name="amount"
              prependChar="$"
              rules="required|money"
              mode="lazy"
              v-model="formMembership.yearlyAmount"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label class="form-control-label">Description</label>

            <validation-provider
              v-slot="{ errors }"
              :name="label"
              rules="required"
              lazy
            >
              <b-form-textarea
                v-model="formMembership.description"
                rows="3"
                label="Description"
                max-rows="6"
                rules="required"
              ></b-form-textarea>
              <slot name="error">
                <div
                  v-if="errors[0]"
                  class="invalid-feedback"
                  style="display: block"
                >
                  The description is required
                </div>
              </slot>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <label class="form-control-label mt-3">Membership Benefits</label>
            <div
              v-if="pointError"
              class="invalid-feedback"
              style="display: block"
            >
              You must have at least one benefit added to the membership
            </div>
            <draggable
              v-model="formMembership.membershipBenefits"
              group="people"
              @start="drag = true"
              @end="drag = false"
              handle=".handle"
            >
              <div
                v-for="(element, index) in formMembership.membershipBenefits"
                :key="element.id"
              >
                <b-row>
                  <b-col cols="10">
                    <base-input
                      class="mb-3"
                      rules="required"
                      mode="lazy"
                      v-model="element.label"
                    />
                  </b-col>
                  <b-col cols="1" style="text-align: right">
                    <i
                      style="cursor: pointer"
                      class="fa fa-align-justify handle"
                    ></i>
                  </b-col>
                  <b-col cols="1" style="text-align: right">
                    <a href="#" @click.prevent="removePoint(index)"
                      ><i class="fas fa-trash-alt"></i
                    ></a>
                  </b-col>
                </b-row>
              </div>
            </draggable>
            <b-row>
              <b-col cols="8">
                <base-input
                  class="mb-3"
                  name="label"
                  mode="lazy"
                  v-model="newPoint"
                />
              </b-col>
              <b-col cols="2">
                <b-button
                  variant="outline-primary"
                  @click="addNewPoint"
                  class="btn-block"
                  >Add</b-button
                >
              </b-col>
              <b-col cols="2"> </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="pt-4">
          <b-col cols="8">
            <b-button
              type="submit"
              variant="warning"
              class="btn"
              href="#"
              @click.prevent="cancel()"
              >Cancel</b-button
            >
            <b-button type="submit" variant="success" class="btn"
              >Save Membership</b-button
            >
          </b-col>
          <b-col cols="4" class="text-right">
            <b-form-checkbox
              size="md"
              class="ml-4 mb-3"
              switch
              v-model="formMembership.isActive"
              >Active</b-form-checkbox
            >
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
export default {
  name: "edit-membership",
  props: { membership: null },
  created() {
    var self = this;

    self.formMembership = JSON.parse(JSON.stringify(self.membership));
    self.formMembership.monthlyAmount = self.formMembership.monthlyAmount / 100;
    self.formMembership.yearlyAmount = self.formMembership.yearlyAmount / 100;
  },
  methods: {
    getSavings(listPrice, actualPrice) {
      try {
        var per = ((listPrice - actualPrice) / listPrice) * 100;

        if (per >= 0) return per.toFixed(0) + "% Savings";
        else return "";
      } catch {
        return "";
      }
    },
    cancel() {
      this.$emit("complete");
    },
    setBenifitError() {
      var self = this;
      if (self.formMembership.membershipBenefits.length == 0) {
        self.pointError = true;
        return true;
      } else {
        self.pointError = false;
        return false;
      }
    },
    async submit() {
      var self = this;

      if (this.setBenifitError()) return;

      if (self.formMembership.id) {
        var r = await self.$client.post(
          "/api/membership/update",
          self.formMembership
        );
        if (r.data.isSuccess) {
          self.$emitter.emit("success", {
            message: "Membership has been updated",
          });
          self.$emit("complete");
        }
      } else {
        var r = await self.$client.post(
          "/api/membership/add",
          self.formMembership
        );
        if (r.data.isSuccess) {
          self.formMembership.id = r.data.value.id;
          self.$emitter.emit("success", {
            message: "Membership has been added",
          });
          self.$emit("complete");
        }
      }
      console.log(r);
    },
    setImage(image) {
      var self = this;
      self.formMembership.imageId = image;
      self.$refs.selectImageModal.hide();
    },
    changeImage() {
      var self = this;
      self.$refs.selectImageModal.show();
    },

    removePoint(index) {
      this.formMembership.membershipBenefits.splice(index, 1);
      this.setBenifitError();
    },
    addNewPoint() {
      var self = this;

      if (self.newPoint) {
        self.formMembership.membershipBenefits.push({
          id: null,
          label: self.newPoint,
        });
        self.newPoint = "";
        this.setBenifitError();
      } else {
        self.$emitter.emit(
          "error",
          "The benefit field cannot be blank. Please delete or add a benefit description."
        );
      }
    },
  },
  data() {
    return {
      formMembership: {},
      newPoint: null,
      pointSort: [],
      pointError: false,
      cycle: [
        { value: "YEARLY", text: "Yearly" },
        { value: "QUARTERLY", text: "Quarterly" },
        { value: "MONTHLY", text: "Monthly" },
        { value: "DAILY", text: "Daily" },
      ],
      images: [
        { id: "boy_child.jpg", url: "img/membership/boy_child.jpg" },
        { id: "boy_child2.jpg", url: "img/membership/boy_child2.jpg" },
        { id: "girl_child.jpg", url: "img/membership/girl_child.jpg" },
        { id: "girl_child2.jpg", url: "img/membership/girl_child2.jpg" },
        { id: "girl_teen.jpg", url: "img/membership/girl_teen.jpg" },
        { id: "girl_teen2.jpg", url: "img/membership/girl_teen2.jpg" },
        { id: "man_adult.jpg", url: "img/membership/man_adult.jpg" },
        { id: "man_adult2.jpg", url: "img/membership/man_adult2.jpg" },
        { id: "women_adult.jpg", url: "img/membership/women_adult.jpg" },
        { id: "women_adult2.jpg", url: "img/membership/women_adult2.jpg" },
        { id: "women_adult3.jpg", url: "img/membership/women_adult3.jpg" },
        { id: "man_elderly.jpg", url: "img/membership/man_elderly.jpg" },
        { id: "women_elderly.jpg", url: "img/membership/women_elderly.jpg" },
      ],
    };
  },
};
</script>

<style>
.imageButtonContainer {
  position: relative;
  width: 100%;
}

/* Make the image responsive */
.imageButtonContainer img {
  position: relative;
  width: 600px;
  height: auto;
}

/* Style the button and place it in the middle of the container/image */
.imageButtonContainer .btn {
  position: absolute;
  top: 95%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: #555;
  color: white;
  font-size: 16px;
  padding: 12px 24px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
}

.imageButtonContainer .btn:hover {
  background-color: black;
}
</style>
